import { Button, Col, Collapse, DatePicker, Drawer, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import swal from 'sweetalert'

import { CaretRightOutlined } from '@ant-design/icons'
import moment from 'moment'
import { FiFilter } from 'react-icons/fi'
import { useGetProductCampaignFiltersOffline } from '../../../../ReactQueryhooks/campaignHooks'
import { useGetAllNewReturningAnalysis } from '../../../../ReactQueryhooks/reportHooks'

const NewRetFilterDrawer = ({
  loaderBtn,
  setAdvenceSerach,
  setTableLoader,
  setStartDate,
  setEndDate,
  setLocation,
  location,
  setFilterApplied,
  startDate,
  endDate,
  getMode,
  reportTypes,
}) => {
  const giveNewDate = (days) => {
    return moment().subtract(days, 'days').format('YYYY-MM-DD')
  }
  const { Panel } = Collapse
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  // const mode = localStorage.getItem('customer-mode')

  const productFilters = useSelector((state) => state.generalReducer.productFiltersOffline)

  const productCampaignFiltersOffMutateState = useGetProductCampaignFiltersOffline(dispatch)
  const allNewReturningAnalysisMutateState = useGetAllNewReturningAnalysis(dispatch)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }
  useEffect(() => {
    setAdvenceSerach(allNewReturningAnalysisMutateState.isLoading)
    productCampaignFiltersOffMutateState.mutate()
  }, [])

  console.log(
    '🚀 ~ file: FilterDrawer.js:231 ~ productCampaignFiltersOffMutateState?.data:',
    productCampaignFiltersOffMutateState?.data,
  )

  const filterFunc = async () => {
    if (!startDate && !endDate && !location) {
      return swal('', 'Select at least one filter ', 'error')
    } else if (!startDate || !endDate) {
      return swal('', 'Can not apply date filter without both dates ', 'error')
    } else {
      setFilterApplied(true)
      setTableLoader(true)
      allNewReturningAnalysisMutateState.mutate(
        {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          shopname: location,
        },
        {
          onSuccess: () => {
            setTableLoader(false)
          },
        },
      )
    }

    onClose()
  }

  return (
    <>
      <Button
        disabled={loaderBtn}
        // disabled={Data && Data.length > 0 ? false : true}
        type='primary'
        icon={<FiFilter />}
        onClick={showDrawer}
        className='more-button'
      >
        More Filter
      </Button>
      <Drawer
        title='More Filters'
        placement='right'
        width='30%'
        closable
        maskClosable={false}
        onClose={onClose}
        open={visible}
      >
        <div>
          <Collapse
            // accordion
            expandIconPosition='right'
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            bordered={false}
            defaultActiveKey={['1', '2', '3']}
          >
            {getMode === 'offline' ? (
              <Col xs={24} style={{ border: 'none', backgroundColor: 'white' }}>
                <p>Filter By Location</p>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder='Select Location'
                  loading={productFilters ? false : true}
                  mode='tags'
                  allowClear
                  optionFilterProp='children'
                  value={location}
                  onChange={(value) => setLocation(value)}
                >
                  {productFilters?.locations?.map((location, index) => (
                    <Select.Option key={index} value={location}>
                      {location}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
            ) : (
              <></>
            )}
            <Panel header='Filter Date Wise' key='3'>
              <div>
                <p>Specify Start and Ending Date</p>
                <DatePicker.RangePicker
                  style={{ width: '100%' }}
                  value={[startDate, endDate]}
                  onChange={(date) => {
                    setStartDate(date?.[0])
                    setEndDate(date?.[1])
                  }}
                />
              </div>
            </Panel>
          </Collapse>
        </div>
        <div>
          <Button
            style={{ marginBottom: '0.625rem' }}
            type='primary'
            // loading={loading}
            onClick={filterFunc}
          >
            Apply
          </Button>
          <Button
            type='primary'
            // loading={loading}
            onClick={() => {
              setTableLoader(true)
              let payload
              payload = {
                startDate: giveNewDate(1),
              }

              dispatch({
                type: reportTypes.GET_NEWRETURNING_ANALYSIS,
                payload: null,
              })

              allNewReturningAnalysisMutateState.mutate(
                { ...payload },
                {
                  onSuccess: () => {
                    setTableLoader(false)
                  },
                },
              )

              onClose()
              setFilterApplied(false)
              setStartDate(null)
              setEndDate(null)
              setLocation(undefined)
            }}
          >
            Clear Filters
          </Button>
        </div>
      </Drawer>
    </>
  )
}

export default NewRetFilterDrawer
